import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "passwordConfirmation", "lowercaseCheck", "uppercaseCheck", "numberCheck", "lengthCheck", "submitButton", "mismatchMessage"]

  connect() {
    this.validatePasswords()
  }

  validatePasswords() {
    const password = this.passwordTarget.value
    const passwordConfirmation = this.passwordConfirmationTarget.value

    // Check lowercase letter
    const hasLowercase = /[a-z]/.test(password)
    this.updateCheck(this.lowercaseCheckTarget, hasLowercase)

    // Check uppercase letter  
    const hasUppercase = /[A-Z]/.test(password)
    this.updateCheck(this.uppercaseCheckTarget, hasUppercase)

    // Check number
    const hasNumber = /\d/.test(password)
    this.updateCheck(this.numberCheckTarget, hasNumber)

    // Check minimum 8 characters
    const hasMinLength = password.length >= 8
    this.updateCheck(this.lengthCheckTarget, hasMinLength)

    // Enable/disable submit button based on all validations
    const allValid = hasLowercase && hasUppercase && hasNumber && hasMinLength && password === passwordConfirmation && password.length > 0
    this.submitButtonTarget.disabled = !allValid

    // Show/hide mismatch message
    if (password && passwordConfirmation && password !== passwordConfirmation) {
      this.mismatchMessageTarget.classList.remove('hidden')
    } else {
      this.mismatchMessageTarget.classList.add('hidden')
    }
  }

  updateCheck(element, isValid) {
    const icon = element.querySelector('svg')
    if (isValid) {
      element.classList.remove('text-gray-400')
      element.classList.add('text-frankly-green-600')
      icon.innerHTML = `
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
      `
    } else {
      element.classList.remove('text-frankly-green-600')
      element.classList.add('text-gray-400')
      icon.innerHTML = `
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
      `
    }
  }
}